import React from "react";
import { Col, Row } from "react-bootstrap";
import { NFTextInput } from "../../../Shared/NewForms/NFTextInput";
import { NFLookupPerson } from "../../../Shared/NewForms/NFlookupPerson";
import { NFLookupUser } from "../../../Shared/NewForms/NFLookupUser";
import { NFLookupCompany } from "../../../Shared/NewForms/NFLookupCompany";
import { NFLookupPosition } from "../../../Shared/NewForms/NFLookupPosition";
import { NFLookupCurrency } from "../../../Shared/NewForms/NFlookupCurrency";
import { NFLookupWarehouse } from "../../../Shared/NewForms/NFLookupWarehouse";
import { useTranslation } from "react-i18next";

const UserDetailMain = () => {
  const {t} = useTranslation();
  return (
    <>
      <Row>
        <Col sm={6}>
          <NFTextInput title={t("username")} fieldName={"userName"} />
        </Col>
        <Col sm={6}>
          <NFTextInput title={t("email")} fieldName={"email"} />
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
          <NFLookupPerson title={t("Person")} fieldName={"personId"} required />
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
          <NFLookupUser title={t("User")} fieldName={"userSetting.userId"} required />
        </Col>
        <Col sm={6}>
          <NFTextInput title={t("Phone")} fieldName={"userSetting.phone"} required />
        </Col>
        <Col sm={6}>
          <NFTextInput title={t("currentLocale")} fieldName={"userSetting.currentLocale"} />
        </Col>
        <Col sm={6}>
          <NFTextInput title={t("timezone")} fieldName={"userSetting.timezone"} />
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
          <NFLookupPosition title={t("position")} fieldName={"userSetting.positionId"} />
        </Col>
        <Col sm={6}>
          <NFLookupCurrency title={t("Currency")} fieldName={"userSetting.defaultCurrencyId"} />
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
          <NFLookupCompany title={t("Company")} fieldName={"userSetting.defaultCompanyId"} />
        </Col>
        <Col sm={6}>
          <NFLookupWarehouse title={t("warehouse")} fieldName={"userSetting.defaultWarehouseId"} />
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
          <NFLookupUser title={t("userSettingId")} fieldName={"userSettingId"} />
        </Col>
        <Col sm={6}>
          <NFLookupUser title={t("Application user")} fieldName={"applicationUserId"} />
        </Col>
      </Row>
    </>
  );
};

export default UserDetailMain;
